import { Sex as SexZod } from '@/fetching/sharedSchemas/basicSchemas';

import { Sex as SexGql } from './graphql';

/** @deprecated Use Sex imported from 'gql-types' */
export enum Sex {
    MALE = 'MALE',
    FEMALE = 'FEMALE',
    INTERSEX = 'INTERSEX',
    UNKNOWN = 'UNKNOWN',
}

export const renderSex = (sex: Sex): string => {
    switch (sex) {
        case Sex.MALE:
            return 'Male';
        case Sex.FEMALE:
            return 'Female';
        case Sex.INTERSEX:
            return 'Intersex';
        case Sex.UNKNOWN:
            return 'Unknown';
        default:
            // Fall back to the raw value rather than throwing (matches
            // renderCompensationType): this renders read-only in the clinician
            // header, so a value the frontend hasn't mapped yet (e.g. a newly-added
            // backend enum served to a stale schema package) shouldn't take the
            // whole page down. Write paths (sexToCode/codeToSex) still throw.
            return sex;
    }
};

// Temp: conversion between graphql and zod types
export const sexToCode = (sex: Sex): string => {
    switch (sex) {
        case Sex.MALE:
            return 'M';
        case Sex.FEMALE:
            return 'F';
        case Sex.INTERSEX:
            return 'I';
        case Sex.UNKNOWN:
            return 'U';
        default:
            throw new Error(`Unknown sex: ${sex as string}`);
    }
};
export const codeToSex = (code: string): Sex => {
    switch (code) {
        case 'M':
            return Sex.MALE;
        case 'F':
            return Sex.FEMALE;
        case 'I':
            return Sex.INTERSEX;
        case 'U':
            return Sex.UNKNOWN;
        default:
            throw new Error(`Unknown sex code: ${code}`);
    }
};

// Temp: conversion between graphql and zod types
export const sexToZod = (sex: Sex): SexZod => {
    return { code: sexToCode(sex), name: renderSex(sex) };
};

export const availableSexes = Object.values(Sex).map(sexToZod);

// TODO: rename this/remove other function once we've migrated to only the graph Sex enum
// It's unfortunate that we have multiple different Sex enums
export const sexToCodeGql = (sex: SexGql): string => {
    switch (sex) {
        case SexGql.MALE:
            return 'M';
        case SexGql.FEMALE:
            return 'F';
        case SexGql.INTERSEX:
            return 'I';
        case SexGql.UNKNOWN:
            return 'U';
        default:
            throw new Error(`Unknown sex: ${sex as string}`);
    }
};
